import React, { useState, useEffect } from 'react';

import Staralt from './components/Staralt';
import config from "./config.json";

import { useUTCTime } from './Hooks/Dates';
import TargetsTable from './components/TargetsTable';
import AddTarget from './components/AddTarget';
import DatePicker from './components/DatePicker';

function Observability() {
    const utc = useUTCTime();

    // Inicializa la fecha con el día de hoy en formato 'YYYY-MM-DD'
    const [selectedDate, setSelectedDate] = useState(utc.format('YYYY-MM-DD'));
    
    // Función para manejar el cambio de fecha desde el DatePicker
    const handleDateChange = (newDateStr) => {
        setSelectedDate(newDateStr);
    };

    // Estado centralizado de targets
    const [targets, setTargets] = useState(() => {
        const stored = localStorage.getItem('targets');
        return stored ? JSON.parse(stored) : [];
    });

    // Sincronizar con localStorage cuando cambie el estado
    useEffect(() => {
        localStorage.setItem('targets', JSON.stringify(targets));
    }, [targets]);

    // Función para añadir un nuevo target
    const addTarget = (newTarget) => {
        setTargets(prev => [...prev, newTarget]);
    };

    // Función para eliminar un target
    const deleteTarget = (name) => {
        setTargets(prev => prev.filter(t => t.name !== name));
    };

    return (
        <div className='my-4'>
            <Staralt 
                observer_location={config.location}
                obsdate_yyyymmdd={selectedDate}
                night_mode="True"
                minimum_altitude={0}
                div_height="600px"
                targets={targets}
            />

            <div className="ms-5 p-3">
                <DatePicker 
                initialDate={selectedDate} 
                onDateChange={handleDateChange} 
                />
            </div>
            
            <section className="ms-5 p-3">
                <AddTarget onTargetAdded={addTarget} />
            
                <TargetsTable 
                    targets={targets}
                    onDelete={deleteTarget} 
                /> 
            </section>
        </div>
    );
}

export default Observability;